export enum SegmentFileStatus {
    Uploaded,
    NonValid,
    Valid
}